<template>
  <div class="modal fade" :id="modalId" tabindex="-1" data-bs-backdrop="static" style="z-index: 1075">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">

        <div class="modal-header">
          <h5 class="modal-title">{{ $t('user.create') }}</h5>
          <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
            <span class="svg-icon svg-icon-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"/>
                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"/>
              </svg>
            </span>
          </div>
        </div>

        <div class="modal-body">
          <form @submit.prevent="submit">

            <!-- Genre -->
            <div class="d-flex flex-column mb-6 fv-row">
              <label class="required d-flex align-items-center fs-6 fw-bold mb-2">
                {{ $t('user.gender') }}
              </label>
              <select
                :id="`${modalId}-gender`"
                name="cum_gender"
                class="form-select form-select-solid"
                required
                :data-dropdown-parent="'#' + modalId"
              >
                <option value="">{{ $t('user.civility') }}</option>
                <option value="female">{{ $t('user.female') }}</option>
                <option value="male">{{ $t('user.male') }}</option>
              </select>
            </div>

            <!-- Nom + Prénom -->
            <div class="row">
              <div class="col-md-6">
                <div class="d-flex flex-column mb-6 fv-row">
                  <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                    <span class="required">{{ $t('user.lastname') }}</span>
                  </label>
                  <input
                    type="text"
                    required
                    class="form-control form-control-solid"
                    v-model="form.lastname"
                    :placeholder="$t('user.lastname_placeholder')"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-6 fv-row">
                  <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                    <span class="required">{{ $t('user.firstname') }}</span>
                  </label>
                  <input
                    type="text"
                    required
                    class="form-control form-control-solid"
                    v-model="form.firstname"
                    :placeholder="$t('user.firstname_placeholder')"
                  />
                </div>
              </div>
            </div>

            <!-- Email + Téléphone -->
            <div class="row">
              <div class="col-md-6">
                <div class="d-flex flex-column mb-6 fv-row">
                  <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                    <span class="required">{{ $t('user.email') }}</span>
                  </label>
                  <input
                    type="email"
                    required
                    class="form-control form-control-solid"
                    v-model="form.email"
                    :placeholder="$t('user.email_placeholder')"
                  />
                </div>
              </div>
              <InputTel
                :name="`${modalId}-phone`"
                :label="$t('user.phone')"
                containerClass="col-md-6 mb-6"
                labelClass="fs-6 fw-bold mb-2"
                inputClass="form-control form-control-sm form-control-solid"
                v-model:phone="form.phone"
                v-model:phone-code="form.phone_code"
                :placeholder="$t('enter_phone')"
                :isRequired="false"
              />
            </div>

            <!-- Rôle -->
            <div class="d-flex flex-column mb-6 fv-row">
              <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                {{ $t('user.right') }}
              </label>
              <select
                :id="`${modalId}-role`"
                name="cum_role"
                class="form-select form-select-solid"
                data-allow-clear="true"
                :data-dropdown-parent="'#' + modalId"
                :data-placeholder="$t('user.role_placeholder')"
              >
                <option value=""></option>
                <option v-for="role in roles" :key="role.id" :value="role.id">{{ role.name }}</option>
              </select>
            </div>

            <!-- Info mot de passe -->
            <div class="alert d-flex align-items-center p-4 mb-4" style="background-color: #d8f6cc;">
              <span class="fs-7 text-gray-700">{{ $t('user.alert_password') }}</span>
            </div>

            <div class="modal-footer px-0 pb-0">
              <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal">
                {{ $t('button.close') }}
              </button>
              <button type="submit" class="btn btn-sm btn-primary fw-bolder" :disabled="isLoading">
                <span class="indicator-label">{{ $t('button.save') }}</span>
                <span v-if="isLoading" class="spinner-border spinner-border-sm align-middle ms-2"></span>
              </button>
            </div>

          </form>
        </div>

      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, nextTick } from 'vue'
import { useStore } from 'vuex'
import InputTel from '@/components/InputTel.vue'
import i18n from '@/plugins/i18n'

const props = defineProps({
  modalId: {
    type: String,
    default: 'createUserModal',
  },
})

const emit = defineEmits(['user-created'])

const store = useStore()
const isLoading = ref(false)

const roles = computed(() => store.getters['role/roles'] || [])

const emptyForm = () => ({
  gender: '',
  lastname: '',
  firstname: '',
  email: '',
  phone: '',
  phone_code: '',
  role: null,
})

const form = ref(emptyForm())

function initSelects() {
  KTApp.initSelect2()

  const genderSel = $(`#${props.modalId}-gender`)
  genderSel.select2({ dropdownParent: $(`#${props.modalId}`) })
  genderSel.off('change.cum').on('change.cum', (e) => {
    form.value.gender = e.target.value
  })

  const roleSel = $(`#${props.modalId}-role`)
  roleSel.select2({ dropdownParent: $(`#${props.modalId}`), allowClear: true, placeholder: i18n.global.t('user.role_placeholder') })
  roleSel.off('change.cum').on('change.cum', (e) => {
    form.value.role = e.target.value || null
  })
}

async function open() {
  await store.dispatch('role/loadRole')
  $(`#${props.modalId}`).modal('show')
  await nextTick()
  initSelects()
}

function close() {
  $(`#${props.modalId}`).modal('hide')
}

async function submit() {
  if (!form.value.gender) {
    window.toastr['error'](i18n.global.t('user.gender') + ' ' + i18n.global.t('validation.required'))
    return
  }
  isLoading.value = true
  try {
    const response = await store.dispatch('user/createUser', form.value)
    const user = response?.data?.user
    if (user) {
      window.toastr['success'](i18n.global.t('notification.user_created'))
      emit('user-created', {
        id: user.id,
        fullname: (user.lastname + ' ' + user.firstname).trim(),
      })
      form.value = emptyForm()
      // reset les selects
      $(`#${props.modalId}-gender`).val('').trigger('change')
      $(`#${props.modalId}-role`).val(null).trigger('change')
      close()
    }
  } catch {
    // géré par l'intercepteur axios global
  } finally {
    isLoading.value = false
  }
}

defineExpose({ open, close })
</script>
